/* prettier-ignore */

import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { IDatasource } from 'ngx-ui-scroll';

@Component({
  selector: 'cicerone-list-events',
  templateUrl: './list-events.component.html',
  styleUrls: ['./list-events.component.scss'],
  encapsulation: ViewEncapsulation.None,
  
})

export class ListEventsComponent {
  @Input() events?: any;
  
  private _imageCounter = 0; // Counter for cycling through 1-4
  private _itemImageMap = new Map<string, number>(); // Cache images per item

  datasource: IDatasource = {
    get: (index, count, success) => {
      const data = [];
      for (let i = index; i <= index + count - 1; i++) {
        if (this.events?.length > i)
          data.push({type: 'item', data: this.events[i]});
        // else if (this.events?.length === i)
        //   data.push({type: 'more', data: []})
      }
      success(data);
    },
    settings: {
      horizontal: true,
      minIndex: 0,
      startIndex: 0
    }
  };

  constructor(
    public translate: TranslateService, 
    private router: Router
  ) {}
  
  goToSubCategoriesList(itemID) {
    this.router.navigate([`/${itemID}`]);
  }

  public getDefaultImgFileName(itemId: string): string {
    // Create unique key for this item
    const itemKey = `event-${itemId}`;
    
    // Return cached image if exists
    if (this._itemImageMap.has(itemKey)) {
      const imageNumber = this._itemImageMap.get(itemKey)!;
      return `/assets/imgs/default/event/event-${imageNumber}.webp`;
    }
    
    // Increment counter and cycle between 1-4 (NO reset per item)
    this._imageCounter = (this._imageCounter % 4) + 1;
    
    // Cache the image number for this item
    this._itemImageMap.set(itemKey, this._imageCounter);
    
    return `/assets/imgs/default/event/event-${this._imageCounter}.webp`;
  }
}
